import { getNextgenSettingsUrl } from '@jira/project-settings__get-settings-url/src/getClassicIssueLayoutSettingsUrl.tsx';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';

export const createProjectUrl = (projectKey: string) => `/browse/${encodeURIComponent(projectKey)}`;

export const createProjectSettingsUrl = (
	projectKey: string,
	projectType: ProjectType,
	isSimplified: boolean,
) => {
	if (isSimplified) {
		return getNextgenSettingsUrl(projectType, projectKey);
	}
	return `/projects/${projectKey}/settings`;
};

export const createBoardUrl = (boardId: number) => `/secure/RapidBoard.jspa?rapidView=${boardId}`;
